import { NetworkStatus } from '@cbridge-utils/network';
import { IOrderLifetimeStore } from './orderLifetime.interface';

export const ORDER_LIFETIME_TIMEOUT_MIN = 1000;
export const ORDER_LIFETIME_TIMEOUT_MAX = 180000;

export const orderLifetimeInitialState: IOrderLifetimeStore = {
  data: {},
  defaultData: {
    marketIocTimeout: undefined,
    marketGtcTimeout: undefined,
    limitIocTimeout: undefined,
    limitGtcTimeout: undefined,
    limitFokTimeout: undefined,
    marketFokTimeout: undefined,
  },
  networkStatus: NetworkStatus.None,
};
